<template>
  <div class="page-content store-items">
    <p-button
      type="yellow"
      round
      native-type="submit"
      class="mb-3"
      @click="clearStore"
    >
      <i class="nc-icon nc-minimal-left mr-2" />Back to Search
    </p-button>

    <p-button
      type="warning"
      round
      native-type="button"
      class="mb-3"
      @click="clearCart"
    >
      Clear Cart
    </p-button>

    <div
      v-if="storeGroupInternal"
      class="row"
    >
      <div class="col-12">
        <div class="card">
          <div
            v-loading="status.isLoading"
            class="card-content py-4"
            element-loading-text="Loading restaurant menu..."
            element-loading-custom-class="custom-spinner-class"
          >
            <h4 class="my-0">
              {{ storeGroupInternal.title }}
            </h4>
            <div class="mt-2">
              {{ storeGroupInternal.subtitle }}
            </div>
            <div class="mt-2">
              <b>Available on:</b>
              <span
                v-for="(value, name, index) in storeServiceIds"
                :key="name"
                class="service-name"
              >
                <span v-if="index > 0">, </span>
                {{ name }} ({{ value.length }})
              </span>
            </div>
            <div class="mt-2">
              <span v-if="deliveryFee">
                <b>Delivery Fee:&nbsp;</b>
                <span class="service-name">
                  {{ deliveryFee }}
                </span>
              </span>
              <span v-if="averageRating">&nbsp;•&nbsp;{{ averageRating }} <i class="fa fa-star" /></span>
              <span v-if="ratings">&nbsp;({{ ratings }})</span>
              <span v-if="distance">&nbsp;•&nbsp;{{ distance }}</span>
              <span v-if="timeEstimate">&nbsp;•&nbsp;{{ timeEstimate }} mins</span>
              <span v-if="priceRange">&nbsp;•&nbsp;{{ priceRange }}</span>
            </div>
            <div
              v-if="menuList"
              class="mt-2 menu-list-wrap"
            >
              <b>Menu:&nbsp;</b>
              <div class="menu-list">
                <dropdown-list
                  :model-value="menuId"
                  value-key="id"
                  :options="menuList"
                  @change="onChangeMenu"
                />
              </div>
            </div>

            <div id="cart">
              <div
                v-if="estimate.noAsapDelivery"
                id="cart-asap-warning"
              >
                <i class="fa fa-exclamation-triangle" />
                <p>At the current time the delivery is not possible,</p>
                <p>but should become available soon.</p>
                <p>It should still be possible to schedule the order.</p>
              </div>
              <div id="cart-buttons">
                <el-tooltip
                  placement="left"
                  :disabled="!estimate.charges"
                >
                  <template #content>
                    <div id="tooltip-content">
                      <div
                        v-for="charge in estimate.charges"
                        :key="charge.title"
                        class="row"
                      >
                        <div class="col-7 charge-title">
                          {{ charge.title }}
                        </div>
                        <div class="col-5">
                          ${{ (charge.value / 100).toFixed(2) }}
                        </div>
                      </div>
                    </div>
                  </template>
                  <p-button
                    v-loading="isEstimateLoading"
                    type="purple"
                    element-loading-custom-class="custom-spinner-class cart"
                    :disabled="!estimate.total"
                    @click="$emit('checkout')"
                  >
                    <i class="nc-icon nc-cart-simple mr-2" /> Items ({{ cart.length }})
                    <div>${{ estimate.total ? (estimate.total / 100).toFixed(2) : '0.00' }}</div>
                  </p-button>
                </el-tooltip>

                <p-button
                  type="button"
                  class="cancel-estimate"
                  :disabled="!isEstimateLoading"
                  @click="$emit('cancel-estimate')"
                >
                  Cancel
                </p-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="storeItems.length > 0"
      class="row"
    >
      <div class="col-12">
        <div class="card">
          <div class="card-content py-4">
            <h4 class="my-0">
              Filter Options
            </h4>
            <div class="filters">
              <div class="row align-items-end mt-10">
                <div class="col-sm-8">
                  <el-autocomplete
                    v-model="itemCost"
                    clearable
                    popper-class="filters__popper-autocomplete"
                    placeholder="Type here Maximum Cost of the Item"
                    :debounce="1000"
                    :fetch-suggestions="filterItemsByCost"
                    @input="status.costFilterLoading = true"
                  >
                    <template #prepend>
                      $
                    </template>
                    <template #suffix>
                      <div
                        v-loading="status.costFilterLoading"
                        class="filters__loading"
                      />
                    </template>
                  </el-autocomplete>
                </div>
                <div class="col-sm-2 filters__help-icon">
                  <el-popover
                    placement="top-start"
                    :width="400"
                    trigger="hover"
                    popper-class="delivery-detail-popover"
                    content="Filter groups by item's cost"
                  >
                    <template #reference>
                      <i class="el-icon-question" />
                    </template>
                  </el-popover>
                </div>
              </div>
              <div class="row align-items-end mt-10">
                <div class="col-sm-8">
                  <el-autocomplete
                    v-model="searchKey"
                    clearable
                    popper-class="filters__popper-autocomplete"
                    placeholder="Type here Item Name for Search"
                    :fetch-suggestions="searchItems"
                    :debounce="1000"
                    @input="status.nameFilterLoading = true"
                  >
                    <template #prepend>
                      $
                    </template>
                    <template #suffix>
                      <div
                        v-loading="status.nameFilterLoading"
                        class="filters__loading"
                      />
                    </template>
                  </el-autocomplete>
                </div>
                <div class="col-sm-2 filters__help-icon">
                  <el-popover
                    placement="top-start"
                    :width="400"
                    trigger="hover"
                    popper-class="delivery-detail-popover"
                    content="Search by Item's name"
                  >
                    <template #reference>
                      <i class="el-icon-question" />
                    </template>
                  </el-popover>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="searchItemsResult.length > 1 && storeGroupInternal"
      v-loading="status.nameFilterLoading"
      class="card search-results"
    >
      <div class="card-body table-view">
        <h4 class="my-0 search-results__title">
          Search Results for the Key "{{ searchKey }}"
        </h4>
        <el-table
          :data="searchItemsResult"
          border
          fit
          height="350"
        >
          <el-table-column
            v-for="(item, index) in locationsTableColumns"
            :key="index"
            :prop="item.field"
            :label="item.label"
            :width="item.width"
            :formatter="item.formatter"
          >
            <template #default="scope">
              <div
                v-if="item.field === 'title'"
                v-dompurify-html="markSearchSubString(scope.row?.title)"
              />
              <span v-else>
                {{ item.formatter ? item.formatter(scope.row) : scope.row && scope.row[item.field] }}
              </span>
            </template>
          </el-table-column>

          <el-table-column
            :fixed="true"
            :width="100"
            align="right"
            label=""
          >
            <template #default="scope">
              <el-button
                v-if="enabledServicesOrdering?.includes(scope.row?.service)"
                size="small"
                :disabled="
                  visibleService && visibleStoreId ? visibleService !== scope.row?.service || visibleStoreId !== scope.row?.storeId : false
                "
                @click.stop="addItem(scope.row)"
              >
                Add
              </el-button>
              <el-button
                v-else
                size="small"
                @click.stop="openUrl(scope.row?.storeId)"
              >
                Website
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div
      v-for="(section, index) in filteredStoreItems"
      id="results"
      :key="index"
      v-loading="status.costFilterLoading"
      class="row"
    >
      <div class="col-12">
        <h5>{{ section.title }}</h5>
        <div class="mb-4">
          {{ section.subtitle }}
        </div>
      </div>

      <div
        v-for="(item, itemIdx) in section.itemGroups"
        :key="itemIdx"
        class="result"
        :class="{ 'active-item': activeItem == item }"
        @click="toggleStoreItem(item)"
      >
        <div
          v-if="storeGroupInternal"
          v-loading="item.items.map((t) => t.id).includes(loadingItemId)"
          class="card store-item"
          element-loading-text="Loading item options..."
          element-loading-custom-class="custom-spinner-class"
          :class="{ disabled: !hasAvailableItem(item) }"
        >
          <div class="card-body">
            <div class="card-title">
              <div
                class="item-title h6"
                :title="item.title"
              >
                {{ item.title }}
              </div>
              <div
                v-show="activeItem == item"
                class="item-subtitle"
              >
                {{ item.subtitle }}
              </div>
              <div
                v-if="item.items.length && item.items[0].imageUrl"
                class="item-img"
                :style="{ 'background-image': `url(${item.items[0].imageUrl})` }"
              />
              <div
                v-else
                class="item-img"
                :style="{ 'background-image': 'url(/static/img/resto-image-not-available.jpg)' }"
              />
            </div>

            <div
              v-show="activeItem == item"
              class="table-view"
            >
              <el-table
                :data="item.items"
                border
                fit
                height="150"
              >
                <el-table-column
                  v-for="(tblItem, index1) in locationsTableColumns"
                  :key="index1"
                  :prop="tblItem.field"
                  :label="tblItem.label"
                  :width="tblItem.width"
                  :formatter="tblItem.formatter"
                />

                <el-table-column
                  :fixed="true"
                  :width="100"
                  align="right"
                  label="Action"
                >
                  <template #default="scope">
                    <el-button
                      v-if="enabledServicesOrdering.includes(scope.row?.service)"
                      size="small"
                      :disabled="
                        visibleService && visibleStoreId
                          ? visibleService !== scope.row?.service || visibleStoreId !== scope.row?.storeId
                          : false
                      "
                      @click.stop="addItem(scope.row)"
                    >
                      Add
                    </el-button>
                    <el-button
                      v-else
                      size="small"
                      @click.stop="openUrl(scope.row?.storeId)"
                    >
                      Website
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="!section.itemGroups.length"
        class="col-12"
      >
        Unfortunately, we couldn't find any items here. Please try searching at some other time for these items.
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, ref, Ref, reactive, watch, onMounted } from 'vue';
import delay from 'yoctodelay';
import _ from 'lodash';

import util from '@/Utils/util';
import { useCustomer } from '@/use/customer';
import { useSwalDialog } from '@/use/swalDialog';
import { TableColumnType } from '@/models/table';
import { ListType } from '@/models/app';
import { gourmetService } from '@/services/gourmet';

const chromeExtensionId = 'joanepikgpnfagfcpfipoieilpmgmidf';
const enabledServicesOrdering = ['ubereats', 'doordash'];

export default {
  name: 'StoreItems',

  props: {
    storeGroup: {
      type: Object,
      default: () => null,
    },

    deliveryAddress: {
      type: Object,
      default: () => null,
    },

    cart: {
      type: Array<any>,
      default: () => [],
    },

    estimate: {
      type: Object,
      default: () => ({}),
    },

    isEstimateLoading: {
      type: Boolean,
      default: false,
    },

    pendingItem: {
      type: Object,
      default: () => null,
    },

    isDeliveryEstimate: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['checkout', 'cancel-estimate', 'item-options', 'clear-cart', 'clear-store'],

  setup: (props: any, context: any) => {
    const { emit } = context;

    const { customerInfo } = useCustomer();
    const { showErrorPopupDialog, showConfirmPopupDialog } = useSwalDialog();

    const storeServiceIds: Ref<any> = ref([]);
    const storeItems: Ref<any> = ref([]);
    const items: Ref<any> = ref([]);
    const searchItemsResult: Ref<any> = ref([]);
    const address: Ref<any> = ref({});
    const activeItem: Ref<any> = ref(null);
    const menuList: Ref<ListType[]> = ref([]);
    const menuId: Ref<any> = ref(null);
    const storeGroupInternal: Ref<any> = ref(null);
    const filteredStoreItems: Ref<any> = ref([]);
    const visibleService: Ref<string | null> = ref(null);
    const visibleStoreId: Ref<string | null> = ref(null);
    const locationsTableColumns: Ref<TableColumnType[]> = ref([]);
    const searchKey = ref('');
    const itemCost = ref('');
    const loadingItemId = ref('');
    const status = reactive({
      isLoading: true,
      costFilterLoading: false,
      nameFilterLoading: false,
    });

    const distance = computed(() => {
      if (!props.storeGroup.stores || !props.storeGroup.stores.length) {
        return null;
      }

      return props.storeGroup.stores[0].distance;
    });

    const averageRating = computed(() => {
      if (!props.storeGroup.stores || !props.storeGroup.stores.length) {
        return null;
      }

      const averageRating = props.storeGroup.stores[0].averageRating;

      if (!averageRating) {
        return null;
      }

      return averageRating.toFixed(1);
    });

    const ratings = computed(() => {
      if (!props.storeGroup.stores || !props.storeGroup.stores.length) {
        return null;
      }

      return props.storeGroup.stores[0].ratings;
    });

    const timeEstimate = computed(() => {
      if (!props.storeGroup.stores || !props.storeGroup.stores.length) {
        return null;
      }

      const timeEstimate = props.storeGroup.stores[0].timeEstimate;

      if (!timeEstimate) {
        return null;
      }

      if (timeEstimate.min === timeEstimate.max) {
        return timeEstimate.min;
      }

      return [timeEstimate.min, timeEstimate.max].filter((time) => time).join(' ~ ');
    });

    const priceRange = computed(() => {
      if (!props.storeGroup.stores || !props.storeGroup.stores.length) {
        return null;
      }

      const priceRange = props.storeGroup.stores[0].priceRange || 0;

      let priceRangeString = '';

      for (let i = 0; i < priceRange; i += 1) {
        priceRangeString += '$';
      }

      return priceRangeString;
    });

    const deliveryFee = computed(() => {
      if (!props.storeGroup.stores || !props.storeGroup.stores.length) {
        return null;
      }

      return props.storeGroup.stores[0].promotion?.text;
    });

    const filterItems = (service: any, storeId: any) => {
      visibleService.value = service;
      visibleStoreId.value = storeId;
    };

    const addItem = async (item: any) => {
      if (!customerInfo.value?.id && !props.isDeliveryEstimate) {
        return showErrorPopupDialog({
          text: 'Please pull up customer account before adding item',
        });
      }

      const itemDetails = await getItemDetails(item);
      if (itemDetails) {
        emit('item-options', itemDetails, false);
      }
    };

    const searchItems = () => {
      if (searchKey.value && searchKey.value.length > 0) {
        status.nameFilterLoading = true;
        searchItemsResult.value = _.cloneDeep(items.value).filter((item: any) => {
          return item.title.toLowerCase().indexOf(searchKey.value.toLowerCase()) >= 0;
        });
        status.nameFilterLoading = false;
      } else {
        status.nameFilterLoading = false;
        clearItems();
      }
    };

    const markSearchSubString = (title: string) => {
      if (!title || !searchKey.value) {
        return '';
      }

      const index = title.toLowerCase().indexOf(searchKey.value.toLowerCase());
      const substr = title.slice(index, index + searchKey.value.length);
      return title.replace(substr, `<span class="found-substring">${substr}</span>`);
    };

    const clearItems = () => {
      searchItemsResult.value = [];
    };

    const filterItemsByCost = () => {
      const cost = Number(itemCost.value);
      if (cost <= 0) {
        filteredStoreItems.value = storeItems.value;
        status.costFilterLoading = false;
        return;
      }

      status.costFilterLoading = true;
      filteredStoreItems.value = storeItems.value
        .map((storeItem: any) => {
          const itemGroups = storeItem.itemGroups.map((itemGroup: any) => {
            const itemValues = itemGroup.items.filter((item: any) => item.price <= cost * 100);
            return {
              ...itemGroup,
              items: itemValues,
            };
          });

          const filteredItemGroups = itemGroups.filter((itemGroup: any) => itemGroup.items.length > 0);

          return {
            ...storeItem,
            itemGroups: filteredItemGroups,
          };
        })
        .filter((storeItem: any) => storeItem.itemGroups.length > 0);

      status.costFilterLoading = false;
    };

    const loadStoreItems = async (storeGroup: any, menuOptions?: any) => {
      activeItem.value = null;
      storeItems.value = [];
      items.value = [];
      filteredStoreItems.value = [];
      searchKey.value = '';
      itemCost.value = '';
      status.isLoading = true;

      clearItems();

      await delay(4000);

      return doLoadStoreItems(storeGroup, menuOptions);
    };

    const doLoadStoreItems = async (storeGroup: any, menuOptions?: any) => {
      storeGroupInternal.value = storeGroup;
      storeServiceIds.value = getStoreServiceIds(storeGroup);
      try {
        const response = await gourmetService.getStoreItems({
          storeServiceIds: storeServiceIds.value,
          menuOptions,
        });

        address.value = response.address;
        storeItems.value = response.storeItemsSections;

        const storeId = props.storeGroup.stores[0].id;
        const menuOption = response.menuOption;

        if (!menuOption[storeId]) {
          menuList.value = [];
          menuId.value = menuOption[storeId]?.menuId || null;
        } else {
          const list = menuOption[storeId]?.menuList || [];
          menuId.value = menuOption[storeId]?.menuId || null;
          menuList.value = list.map((item: any) => ({
            id: item.id,
            key: item.id,
            label: `${item.name} (${item.displayOpenHours})`,
          }));
        }

        storeItems.value.forEach((storeItem: any) => {
          storeItem.itemGroups.forEach((itemsGroup: any) => {
            Array.prototype.push.apply(items.value, itemsGroup.items);
          });
        });

        filteredStoreItems.value = _.cloneDeep(storeItems.value);
      } catch (error) {
        const errorText = util.getGraphqlError(error, false);
        showErrorPopupDialog({
          text: errorText,
        });
      }
      status.isLoading = false;
    };

    const getItemDetails = async (item: any) => {
      loadingItemId.value = item?.id;

      try {
        const response = await gourmetService.getItemDetails({
          item,
        });

        return response;
      } catch (error) {
        const errorText = util.getGraphqlError(error, false);
        showErrorPopupDialog({
          text: errorText,
        });
      } finally {
        loadingItemId.value = '';
      }
    };

    const onChangeMenu = async (value: any) => {
      if (props.cart.length) {
        const isConfirmed = await showConfirmPopupDialog({
          text: `Note that all cart items (${props.cart.length}) will be cleared if you change menu`,
          title: 'Change Menu?',
          confirmButtonText: 'Change',
          cancelButtonText: 'Cancel',
          icon: 'warning',
        });

        if (!isConfirmed) {
          return;
        }

        clearCart();
      }

      const storeId = props.storeGroup.stores && props.storeGroup.stores[0]?.id;

      if (!storeId) {
        return;
      }

      loadStoreItems(props.storeGroup, { menuIds: { [storeId]: value } });
    };

    const hasAvailableItem = (item: any) => {
      if (!visibleService.value || !visibleStoreId.value) {
        return true;
      }

      const match = item.items.find(
        (i: { service: string; storeId: string }) => i.service === visibleService.value && i.storeId === visibleStoreId.value,
      );

      return match !== undefined;
    };

    const clearCart = () => {
      emit('clear-cart');
      activeItem.value = null;
    };

    const clearStore = () => {
      let confirm = true;

      if (props.cart.length) {
        confirm = window.confirm('Your cart will be cleared if you go back to the search page.');
      }

      if (confirm) {
        activeItem.value = null;
        storeItems.value = null;
        filteredStoreItems.value = [];
        storeServiceIds.value = null;

        clearItems();
        emit('clear-store');

        storeItems.value = [];
        searchItemsResult.value = [];
        searchKey.value = '';
        itemCost.value = '';
      }
    };

    const toggleStoreItem = (item: object) => {
      if (activeItem.value === item) {
        activeItem.value = null;
      } else {
        activeItem.value = item;
      }
    };

    const getStoreServiceIds = (storeGroup: any) => {
      const stores = storeGroup.stores;
      const serviceIds: any = {};

      for (const storeItem of stores) {
        const service = storeItem.service;

        if (!(service in serviceIds)) {
          serviceIds[service] = [];
        }

        serviceIds[service].push(storeItem.id);
      }

      return serviceIds;
    };

    const openUrl = (storeId: string) => {
      if (!props.deliveryAddress) {
        return;
      }

      const values: any = {
        action: 'setAddress',
        value: props.deliveryAddress,
      };

      const storeItem = storeGroupInternal.value?.stores?.find((item: { id: string }) => item.id == storeId);
      let url = storeItem?.url || '';

      if (!url) {
        return;
      }

      // GrubHub is a special case
      if (url.search('grubhub.com') !== -1) {
        values.goToUrl = url;
        url = 'https://www.grubhub.com/search';
      }

      if (url.search('ubereats.com') !== -1) {
        values.clickFirst = true;
      }

      // Tell the extension to set the address
      chrome.runtime.sendMessage(chromeExtensionId, values, () => {
        window.open(url, '_blank');
      });
    };

    const getAddress = (storeId: any) => {
      if (!address.value) {
        return '';
      }

      return address.value[storeId];
    };

    watch(
      () => props.storeGroup,
      (value: any) => {
        storeGroupInternal.value = value;
        if (!value) {
          return;
        }

        const storeId = value.stores && props.storeGroup.stores[0]?.id;
        if (props.estimate?.menuId && props.estimate?.storeId === storeId) {
          loadStoreItems(value, { menuIds: { [storeId]: props.estimate.menuId } });
        } else {
          loadStoreItems(value);
        }
      },
    );

    watch(
      () => props.cart,
      (value: any) => {
        if (value.length) {
          const item = value[0].item;

          filterItems(item.service, item.storeId);
        } else {
          filterItems(null, null);
        }
      },
    );

    watch(
      () => props.pendingItem,
      (value: any) => {
        if (value && value.item) {
          filterItems(value.item.service, value.item.storeId);
        } else if (!props.cart.length) {
          filterItems(null, null);
        }
      },
    );

    onMounted(() => {
      locationsTableColumns.value = [
        { label: 'Item Name', field: 'title', width: 450 },
        { label: 'Price', field: 'displayPrice', width: 100 },
        { label: 'Service', field: 'service', width: 100 },
        {
          label: 'Open',
          field: 'storeId',
          formatter: (row: any) => {
            const storeItem =
              row && storeGroupInternal.value?.stores && storeGroupInternal.value.stores.find((item: any) => item.id == row.storeId);
            return storeItem?.isAvailable ? 'Yes' : 'No';
          },
          width: 100,
        },
        { label: 'Store Name', field: 'storeTitle', width: 300 },
        {
          label: 'Service Fee',
          field: 'storeId',
          formatter: (row: any) => {
            const storeItem =
              row && storeGroupInternal.value?.stores && storeGroupInternal.value.stores.find((item: any) => item.id == row.storeId);
            return storeItem?.serviceFee && `$${(storeItem.serviceFee / 100).toFixed(2)}`;
          },
          width: 100,
        },
        {
          label: 'Time Estimate',
          field: 'storeId',
          formatter: (row: any) => {
            const storeItem =
              row && storeGroupInternal.value?.stores && storeGroupInternal.value.stores.find((item: any) => item.id == row.storeId);
            return (
              storeItem?.timeEstimate?.min &&
              storeItem?.timeEstimate?.max &&
              `${
                storeItem.timeEstimate.min === storeItem.timeEstimate.max
                  ? storeItem.timeEstimate.min
                  : `${storeItem.timeEstimate.min} - ${storeItem.timeEstimate.max}`
              } mins`
            );
          },
          width: 100,
        },
        { label: 'Address', field: 'address', formatter: (row: any) => row?.storeId && getAddress(row.storeId), width: 300 },
        {
          label: 'Delivery Details',
          field: 'promotion',
          formatter: (row: any) => {
            const promotion = row?.storeId && storeGroupInternal.value && util.getPromotionByStoreId(storeGroupInternal.value, row.storeId);
            return promotion ? promotion.text : '';
          },
          width: 300,
        },
      ];

      storeGroupInternal.value = props.storeGroup;
    });

    return {
      enabledServicesOrdering,
      storeServiceIds,
      storeItems,
      searchItemsResult,
      activeItem,
      storeGroupInternal,
      filteredStoreItems,
      visibleService,
      visibleStoreId,
      locationsTableColumns,
      searchKey,
      itemCost,
      status,
      distance,
      averageRating,
      ratings,
      timeEstimate,
      priceRange,
      deliveryFee,
      loadingItemId,
      menuId,
      menuList,

      addItem,
      searchItems,
      markSearchSubString,
      filterItemsByCost,
      doLoadStoreItems,
      hasAvailableItem,
      clearCart,
      clearStore,
      toggleStoreItem,
      openUrl,
      onChangeMenu,
    };
  },
};
</script>

<style lang="scss">
.page-content .store-items {
  .el-loading-mask {
    left: -2px;
    right: -2px;
    top: -2px;
    bottom: -2px;
  }

  .card-content {
    overflow: hidden;

    .btn-search,
    .btn-filter,
    .btn-clear,
    .btn-filter-clear {
      width: 100px !important;
      height: 42px;
      text-transform: unset;
      border-radius: 10px;
      margin-left: 15px;
    }
  }

  button {
    min-width: 0 !important;
  }

  .cancel-estimate {
    padding: 4px;
  }

  .service-name {
    text-transform: capitalize;
  }
  #results {
    justify-content: center;
    .result {
      justify-content: center;
      width: 250px;
      margin-right: 10px;
      .store-item {
        height: 285px;
        .el-table__body-wrapper {
          &::-webkit-scrollbar {
            -webkit-appearance: none;
            width: 5px;
            height: 5px;
          }
          &::-webkit-scrollbar-thumb {
            border-radius: 5px;
            background-color: rgba(0, 0, 0, 0.5);
            -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
          }
        }
      }
      .item-title {
        height: 50px;
        cursor: pointer;
        font-size: 16px;
        text-align: center;
      }
      .item-img {
        height: 200px;
        max-width: 100%;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
      }
      .card.disabled {
        .card-title {
          opacity: 0.5;
        }

        .item-title {
          text-decoration: line-through;
        }
      }
    }
    .active-item {
      width: 100%;
      max-width: 1000px;
      .store-item {
        height: 470px;
      }
      .card-title {
        display: flex;
        justify-content: center;
        flex-direction: column;
        .item-title {
          height: 20px;
        }
        .item-subtitle {
          height: 58px;
          padding: 5px 5px 0 5px;
          overflow: scroll;
          background-color: #80808014 !important;
          &::-webkit-scrollbar {
            -webkit-appearance: none;
            width: 5px;
          }
          &::-webkit-scrollbar-thumb {
            border-radius: 5px;
            background-color: rgba(0, 0, 0, 0.5);
            -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
          }
        }
        .item-img {
          width: 330px;
          align-self: center;
          margin-top: 5px;
        }
      }
      .table-view {
        .table > tbody > tr,
        .el-table table > tbody > tr {
          background-color: #80808014 !important;
        }
      }
    }
  }
  #cart {
    display: flex;
    position: absolute;
    right: 0;
    top: 0;
  }
  #cart-buttons {
    display: flex;
    flex-direction: column;
  }

  .el-input input[type='number'] {
    max-width: unset !important;
  }
  .filters {
    .el-autocomplete {
      width: 100%;
      input {
        color: black;
        &:focus {
          border-color: #aba5a5;
        }
      }
      input::placeholder {
        color: #343232;
      }
    }
    &__loading {
      width: 30px;
      height: 30px;
      .el-loading-mask {
        top: 1px;
        .el-loading-spinner {
          top: 26px;
          svg {
            width: 30px;
            height: 30px;
          }
        }
      }
    }
    .el-input__suffix-inner {
      display: flex;
    }
    &__help-icon {
      i {
        font-size: 21px;
        position: relative;
        bottom: 6px;
        right: 25px;
      }
    }
  }
  .search-results {
    &__title {
      color: #73040c;
    }
  }

  .menu-list-wrap {
    display: flex;
    align-items: center;

    .menu-list {
      width: 380px;
    }
  }
}

#tooltip-content {
  width: 200px;

  .charge-title {
    text-align: right;
  }
}

.store-item-options:not(:first-child) {
  margin-left: 20px;
}

.el-table__body {
  margin-bottom: 40px;
}
.filters__popper-autocomplete {
  display: none;
}
.found-substring {
  background-color: yellow;
}
#cart-asap-warning {
  padding: 4px;
  background-color: #ffa04f;
  text-wrap: nowrap;
  width: 22rem;
  i {
    float: left;
    font-size: 2em;
    padding: 7px;
  }
}
</style>
